import { VAxios } from '../../define/axios/Axios';

interface DictItem {
  id: string;
  key: string;
  value: string;
  meta: Object;
}

export const createApis = (defHttp: VAxios) => ({
  //#region 获取参数配置
  // 根据字典 key 获取字典值
  getDictsByKeys: (params: { keys: string[] }) =>
    defHttp.get<DictItem[]>({ url: `/dict/dicts`, params }),
  //#endregion

  getDict: (app: string, code: string) => defHttp.get<string>({ url: `/dict/${app}/${code}` }),

  getOpsDict: (key) => defHttp.get({ url: `/dict/ops/${key}` }),
});
